module.exports = __webpack_public_path__ + "assets/img/teacher (28).7ef86a7f.png";